import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/welcome/')({
  beforeLoad: () => {
    throw redirect({
      to: '/welcome/organization-name',
    });
  },
});